export default function regions(state = null, action) {
  switch (action.type) {
    case 'UPDATE_REGIONS': {
      return { ...state, regions: action.payload.regions }
    }

    case 'RECEIVE_RETURN_POLICY': {
      return { ...state, returnPolicy: action.payload }
    }

    default:
      return state
  }
}
